import {RouteNameEnum} from "@/v2/enumerate/route";

const event = [{
	path: "event",
	name: RouteNameEnum.GLORY_EVENT,
	meta: {
		permission: 67001,
		breadcrumb: [{
			key: "glory.event.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/event/index.vue"),
}];

export default event;
